import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { CardModule } from '@spartacus/storefront';
import { GenOrderOverviewComponent } from './order-overview.component';

@NgModule({
    imports: [CommonModule, I18nModule, CardModule],
    declarations: [GenOrderOverviewComponent],
    exports: [GenOrderOverviewComponent],
})
export class GenOrderOverviewModule {}
